<template>
    <v-card v-if="myData != null" flat>
        <v-card-text v-if='localFeedback'>
            {{localFeedback}}
        </v-card-text>
        <v-card-text v-if='!localFeedback'>             
            <v-row v-for="prax, index in myData.praxe" :key="index" align="center">
                <v-col cols=12>
                    <v-card variant="outlined">
                        <v-card-text>
                            <h3>{{prax.firma}} ({{prax.mesto}})</h3>
                            <p><b>Činnosti: </b> {{prax.napln_praxe}}</p>
                        </v-card-text>
                        <v-card-text>
                        <b>Hodnotenie učiteľmi:</b>
                        <v-card variant="outlined" v-for="otazka,index2 in prax.hodnotenia_ucitel" :key="index2" style="margin:2px">
                            <v-card-text>
                                <v-row style="margin:2px" align="center">
                                    {{otazka.otazka}}
                                    <v-spacer />
                                    <v-rating color="green" length="5" v-model="otazka.hodnotenie"
                                        readonly half-increments size="compact" style="scale:1" />
                                    <v-btn size="x-small" variant="outlined" @click="showDetail(otazka.otazka_id,'t', prax.id, index2)">Detail</v-btn>                                                            
                                </v-row>
                                <v-card-text v-if="showDetailIndex == 't'+index2 && myDetail" style="margin:5px">
                                    <v-row v-for="hodnotenie, index3 in myDetail.hodnotenia" :key="index3" align="center">
                                        <v-col cols=12> 
                                            <v-row align="center">
                                                {{hodnotenie.pocet}} x 
                                                <v-rating color="green" length="5" v-model="hodnotenie.otazka_hodnota"
                                                    readonly half-increments size="compact" style="scale:0.75" />
                                            </v-row>
                                            <v-row v-for="komentar, index4 in myDetail.komentare" :key="index4">
                                                <p v-if="komentar.otazka_hodnota == hodnotenie.otazka_hodnota" style="margin-left:10px">
                                                    - {{komentar.otazka_text}} 
                                                </p>
                                        </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                            </v-card-text>
                        </v-card>
                        </v-card-text>
                        <v-card-text style="background-color:#E8F5E9">
                        <b>Hodnotenie študentami:</b>
                        <v-card variant="outlined" v-for="otazka,index2 in prax.hodnotenia_student" :key="index2" style="margin:2px">
                            <v-card-text>
                                <v-row style="margin:2px">
                                    {{otazka.otazka}}
                                    <v-spacer />
                                    <v-rating color="green" length="5" v-model="otazka.hodnotenie"
                                        readonly half-increments size="compact" style="scale:1" />
                                    <v-btn size="x-small" variant="outlined" @click="showDetail(otazka.otazka_id,'s', prax.id, index2)">Detail</v-btn>                                                            
                                </v-row>
                                <v-card-text v-if="showDetailIndex == 's'+index2 && myDetail" style="margin:5px">
                                    <v-row v-for="hodnotenie, index3 in myDetail.hodnotenia" :key="index3" align="center">
                                        <v-col cols=12> 
                                            <v-row align="center">
                                                {{hodnotenie.pocet}} x 
                                                <v-rating color="green" length="5" v-model="hodnotenie.otazka_hodnota"
                                                    readonly half-increments size="compact" style="scale:0.75" />
                                            </v-row>
                                            <v-row v-for="komentar, index4 in myDetail.komentare" :key="index4">
                                                <p v-if="komentar.otazka_hodnota == hodnotenie.otazka_hodnota" style="margin-left:10px">
                                                    - {{komentar.otazka_text}} 
                                                </p>
                                        </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                            </v-card-text>
                        </v-card>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            myData : null,
            myDetail: null,
            localFeedback: '',
            showDetailIndex: -1
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            axios.get('/get-practices-eval-results', this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myData = res.data   
                if (res.data.message != 'OK') {
                    this.localFeedback = res.data.message
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        showDetail(_otazka_id,_user_type, _prax_id, _index) {
            const data = {
                otazka_id: _otazka_id,
                hodnotitel_type: _user_type,
                prax_id: _prax_id
            }
            axios.post('/get-practices-eval-results-details', data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myDetail = res.data
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
                this.showDetailIndex = _user_type+_index
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })

        },
    }
}
</script>